// src/App.js
import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";

import Auth from "./Auth";
import HorseDetail from "./HorseDetail"; // ✅ merged version
import EditHorse from "./EditHorse";
import MyHorses from "./MyHorses";
import AddHorse from "./AddHorse";

import "./App.css";

function App() {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading...</p>;
  }

  return (
    <div className="app-container">
      <h1>AECR</h1>
      <Auth />

      <nav>
        <Link to="/">Home</Link>{" "}
        {user && (
          <>
            | <Link to="/my-horses">My Horses</Link> |{" "}
            <Link to="/AddHorse">Add Horse</Link>
          </>
        )}
      </nav>

      <Routes>
        {/* ✅ Horse detail page (publicly viewable, merged version) */}
        <Route path="/horse/:id" element={<HorseDetail />} />

        {/* Edit form (only for owners) */}
        <Route path="/edit/:id" element={<EditHorse />} />

        {/* Add Horse page */}
        <Route
          path="/AddHorse"
          element={
            user ? (
              <AddHorse />
            ) : (
              <p style={{ textAlign: "center" }}>🚫 Log in to add a horse.</p>
            )
          }
        />

        {/* My Horses (has AddHorse + list inside MyHorses.js) */}
        <Route
          path="/my-horses"
          element={
            user ? (
              <MyHorses />
            ) : (
              <p style={{ textAlign: "center" }}>
                🚫 Log in to view your horses.
              </p>
            )
          }
        />
      </Routes>
    </div>
  );
}

export default App;
